export const CONTAINER_PARTS = [
  'container',
  'containerHeader',
  'containerTitle',
  'containerBody',
  'containerFooter',
] as const;
